import { render, staticRenderFns } from "./InfoText.vue?vue&type=template&id=2d4788ee&scoped=true"
import script from "./InfoText.vue?vue&type=script&lang=js"
export * from "./InfoText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4788ee",
  null
  
)

export default component.exports